import {
  EMPLOYEES_REQUEST_FAIL,
  EMPLOYEES_REQUEST_SUCCESS
} from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.employees, action) {
  switch (action.type) {
    case EMPLOYEES_REQUEST_SUCCESS:
      return { ...action.payload };
    case EMPLOYEES_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/employee/employees.reducer.js